import { useState, useEffect } from 'react';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';

export interface ShipmentStatus {
  id: number;
  name: string;
  is_final?: boolean;
}

interface UseShipmentStatusesOptions {
  finalOnly?: boolean;
}

export const useShipmentStatuses = (options: UseShipmentStatusesOptions = {}) => {
  const { finalOnly = false } = options;
  const [shipmentStatuses, setShipmentStatuses] = useState<ShipmentStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const httpClient = createHttpClient(apiClientWH);

  const loadShipmentStatuses = async () => {
    try {
      setLoading(true);
      setError(null);
      const raw = await httpClient.get<any>('/shipment-statuses');
      const list = Array.isArray(raw) ? raw : (raw?.data ?? []);
      const mapped = list.map((s: any) => ({
        id: s.id,
        name: s.name || s.description || String(s.id),
        is_final: Boolean(s.is_final),
      }));
      setShipmentStatuses(finalOnly ? mapped.filter((s) => s.is_final) : mapped);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar estados de envío');
      console.error('Error loading shipment statuses:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadShipmentStatuses();
  }, [finalOnly]);

  return {
    shipmentStatuses,
    loading,
    error,
    loadShipmentStatuses,
  };
};
